export const BOOK_ROUTE = '/book';
export const IMAGES_ROUTE = '/images';
export const IMAGES_NEW_ROUTE = `${IMAGES_ROUTE}/new`;
export const GREETINGS_ROUTE = '/greetings';
export const GREETINGS_NEW_ROUTE = `${GREETINGS_ROUTE}/new`;
export const REGISTER_ROUTE = '/register';
